module.exports = __webpack_public_path__ + "static/changing-the-face-of-science-image-1-800x533-8a781c201c7e376d2e38d55f05834bf1.jpg";